<template>
  <div>
    <header class="date-content clearfix">
      <div
        v-bind:class="[
          'date-content-left',
          classGoDate == nowDate ? 'color-grey' : ''
        ]"
        v-on:click="changeDate(-1, 1)"
      >
        <span class="iconfont icon-sanjiao-5"></span>前一天
      </div>
      <div class="date-content-date">{{ classGoDate | dateToStr }}</div>
      <div class="date-content-right" v-on:click="changeDate(1, 1)">
        后一天
        <span class="iconfont icon-sanjiao"></span>
      </div>
    </header>
    
     <ul class="class-list" v-if="goClassList.length > 0">
          <li
            v-on:click="selectGoClass(item)"
            class="class-list-content"
            v-for="(item, index) in goClassList"
            :key="index"
          >

          <div v-if="displayStyle==1">
              <div class="clearfix flex " style="margin-top:.1rem;">         
                
               <div class="class-time flex flex-column text-center flex-justify-center">
                      <div>{{ item.ClassTime }}</div>
                      <span class="class-time-tip">
                      {{item.IsFlowSch ? '前有效' : ''}}
                      </span>
                </div>

                <div class="class-node-content">
                      <div class="class-station">
                            <span class="iconfont icon-yuandianzhong"></span>
                            {{item.WaitStName?item.WaitStName:item.StartNodeName }}  
                      </div>
                      <div class="class-node">
                            <span class="iconfont icon-yuandianzhong"> </span>
                          {{ item.ArrivalNodeName }}
                      </div>
                      <div class="class-distance">
                        <span class="iconfont icon-zuobiaofill"></span>
                        线路:{{ item.LineName }}
                        <!-- {{ item.Mileage>0?'-'+item.Mileage+'公里':'' }} {{ item.RunTime | timeToStr }} -->
                      </div>
                </div>

                <div class="class-right-model">
                      <div v-if="item.OfferPrice > 0">
                          <van-tag type="danger">限量优惠:</van-tag>
                          <span class="class-price">￥{{ item.OfferPrice }}</span>
                        </div> 
                        <div class="class-seats">
                          <span v-if="item.CanSaleCount > 0">{{
                            item.CanSaleCount >= 10
                              ? '余位:' + item.CanSaleCount
                              : '(剩' + item.CanSaleCount + '位)'
                          }}</span>
                          <span v-else>已售罄</span>
                          <span class="class-price">￥{{ item.FullPrice }}</span>
                        </div>
                </div>
              </div>
          </div>

          <div class="style_2" v-if="displayStyle==2">
              <div class="clearfix flex flex-column" style="margin-top:.1rem;">  
              
               <div class=" flex flex-row text-left flex-justify-start">
                    <div class="class-time">{{ item.ClassTime }}</div>
                          
                    <div class="class-schedule">
                        <span class="start iconfont icon-yuandianzhong"></span>
                        {{ item.WaitStName?item.WaitStName:item.StartNodeName }} 
                         - 
                        {{ item.ArrivalNodeName }}
                    </div>
                </div>
              <div class=" flex flex-row flex-justify-start">
                   <div class="class-time-tip ">
                      {{item.IsFlowSch ? '前有效' : ''}}
                    </div>  
                    
                    <div class="class-desc">
                        <span class="linename iconfont icon-yuandianzhong"></span>
                        线路：{{ item.LineName }}
                        <!-- {{ item.Mileage>0?' 里程:'+item.Mileage+'公里':'' }} 
                        {{ item.RunTime | timeToStr }} -->
                        <br/>
                        <span v-if="item.ArrivalNodeList" class="linenode iconfont icon-zuobiaofill"></span>
                       {{ item.ArrivalNodeList?'途经：'+item.ArrivalNodeList:'' }}
                        <br/>
                         <span v-if="item.Remark" class="linenode iconfont icon-yuandianzhong"></span>
                       {{ item.Remark?'备注：'+item.Remark:'' }}
                      
                    </div>

              </div>
              <div class="flex flex-row text-right flex-justify-end">
             
                     <div class="class-seats">
                          <span v-if="item.CanSaleCount > 0">
                            {{
                             '(剩:' + item.CanSaleCount+')' 
                          }}
                          </span>
                          <span v-else>已售罄</span>
                     </div>
                     <div class="class-price">
                       ￥{{ item.FullPrice }}
                      </div>
              </div>
              </div>
          </div>
      </li>
    </ul>

    <div
      v-if="goClassList.length == 0 && !isShowLoading"
      style="width: 80%;top: 2rem;position: relative;margin: 0 auto;"
    >
      当前选择的日期地点，暂无成行数据。请切换地点或者日期进行查询！
    </div>
    <div
      v-show="isShowLoading"
      style="position:fixed;top:30%;left:50%;margin-left:-20px;z-index:100000000000;"
    >
      <van-loading color="orange" size="40px" />
    </div>
  </div>
</template>

<script>
import { Tag } from 'vant'
import sysSettings from 'mixins/settings'
export default {
  components: {
    [Tag.name]: Tag
  },
  mixins:[
    sysSettings
  ],
  data() {
    return {
      goClassList: [],
      selectedGoClass: '',
      classGoDate: '',
      nowDate: '',
      startNode: '',
      endNode: '',
      isShowLoading: false,
      displayStyle:2,
    }
  },
  filters: {},
  methods: {
    showLoading: function(flag) {
      this.isShowLoading = flag
    },
    // 日期切换
    changeDate: function(num) {
      if (
        this.classGoDate == this.$moment().format('YYYY-MM-DD') &&
        num == -1
      ) {
        this.$toast('不可选前一天')
        return
      }
      this.classGoDate = this.$moment(this.classGoDate)
        .add(num, 'days')
        .format('YYYY-MM-DD')
      this.getClassData()
    },
    // 选择去程班次
    selectGoClass: function(item) {
      console.log(item)

      
      if(item.CanSaleCount<=0)
      return

      this.saveSelectClass(item)
      this.selectedGoClass = item
      let url = 'placeorder.html?'
      url += this.$utils.getMainUrlParam(1)
      url += '&gid=' + item.GID
      url += '&sgid=' + (item.WaitStCode?item.WaitStName:item.StartNodeGID)
      url += '&agid=' + (item.WaitStCode?item.ArrivalNodeName:item.ArrivalNodeGID)
      url += '&date=' + item.ClassDate
      url += url.includes('st=')?'':'&st=' + item.StartNodeGID

      //前往下单页面
      location.href = url
    },
    // 获取班次数据
    getClassData: function(callBack) {
      let that = this
      that.showLoading(true)
      let params = {}
      params.ClassDate = this.classGoDate
      params.StartNodeGID = this.startNode.gid || this.startNode.name
      params.ArrivalNodeGID = this.endNode.gid || this.endNode.name
      params.startDataSourceCodeList = this.startNode.DataSourceCode
      params.endDataSourceCodeList = this.endNode.DataSourceCode

      if (!params.startDataSourceCodeList) {
        delete params.startDataSourceCodeList
      }
      if (!params.endDataSourceCodeList) {
        delete params.endDataSourceCodeList
      }
      console.log('班次查询--------',params)
      this.$http
        .post(this.$api.API_LineClassDaySaleQuery, this.$qs.stringify(params))
        .then(res => {
          that.showLoading(false)
          console.log(res)
          if (res.success) {
            res.data = that.filterByTime(res.data)
            that.goClassList = res.data
            if(that.goClassList&&that.goClassList.length==1){
              this.selectGoClass(that.goClassList[0])
              return
            }

            if (typeof callBack === 'function') {
              callBack(res)
            }
          } else {
            that.goClassList = []
          }
        })
        .catch(err => {
          that.showLoading(false)
          that.goClassList = []
          console.log(err)
          // this.$dialog.alert({
          //   title: "提示",
          //   message: err
          // });
        })
    },
    saveSelectClass(clas){
          
					let classSelected_hist=this.getLocalData("classSelectHist")||{items:[]}

					//限制历史记录只保存6个
					if(classSelected_hist.items.length>=6){
						classSelected_hist.items.splice(1,1)
					}
					
					let cp_classSelected_exists=classSelected_hist.items.filter(sch=>sch.StartNodeGID==clas.StartNodeGID&&sch.ArrivalNodeGID==clas.ArrivalNodeGID).length>0
					if(!cp_classSelected_exists){
						classSelected_hist.items.push(clas)
            this.setLocalData("classSelectHist",classSelected_hist)
					}       
          
    },
    //时间过滤
    filterByTime: function(data) {
      if (!this.isFilterByTime || data.length === 0) {
        return data
      }
      let ValidData = []
      data.forEach(function(i, v) {
        // 添加提前停售时间逻辑判断
        if (this.$moment().isBefore(v.ClassDate + ' ' + v.ClassTime)) {
          ValidData.push(v)
        }
      })
      return this.shellSort(ValidData, 'ClassTime')
    },
    //排序
    shellSort: function(arr, elname) {
      let arrlen = arr.length
      let temp = null
      let gap = 1
      while (gap < arrlen / 5) {
        // 动态定义间隔序列
        gap = gap * 5 + 1
      }
      for (gap; gap > 0; gap = Math.floor(gap / 5)) {
        for (let i = gap; i < arrlen; i++) {
          temp = arr[i]
          let j
          for (j = i - gap; j >= 0 && arr[j][elname] > temp[elname]; j -= gap) {
            arr[j + gap] = arr[j]
          }
          arr[j + gap] = temp
        }
      }
      return arr
    }
  },
  created() {
    this.startNode = this.$store.state.startNode
    this.endNode = this.$store.state.endNode
    this.classGoDate = this.$route.query.date? this.$route.query.date: this.$moment().format('YYYY-MM-DD')
    this.nowDate = this.$route.query.date
    this.getClassData()
  },
  mounted() {

  }
}
</script>
<style lang="less" scoped>
.date-content {
  line-height: 46px;
  font-size: 14px;
  background-color: #fff;
  margin-bottom: 8px;
}

.date-content .date-content-date {
  width: 50%;
  text-align: center;
  float: left;
  color: #eb5c03;
  font-size: 15px;
  font-weight: 600;
}

.date-content .date-content-left {
  width: 20%;
  float: left;
  padding-left: 5%;
}

.date-content .date-content-right {
  width: 20%;
  text-align: right;
  float: right;
  padding-right: 5%;
}

.date-content .iconfont {
  font-size: 7px;
}

.date-content .icon-sanjiao {
  margin-left: 3px;
}

.date-content .icon-sanjiao-5 {
  margin-right: 3px;
}

.class-list {
  position: absolute;
  top: 56px;
  left: 0;
  bottom: 10px;
  width: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  text-align: left;
}

.class-list-content {
  margin: 0 2% 10px 2%;
  background-color: #fff;
  border-radius: 3px;
  padding: 10px;
}

.class-list-content > div {
  position: relative;
}

.class-list-content .class-time {
  padding-right: 10px;
  text-align: center;
  font-weight: 700;
  font-size: 18px;
}

.class-list-content .class-time .class-time-tip {
  font-size: 12px;
}

.class-list-content > div:nth-child(2) {
  display: flex;
  justify-content: space-between;
}

.class-list-content .class-node-content {
 min-width: 175px;
}

.class-list-content .class-station {
  padding-left: 15px;
  position: relative;
  line-height: 18px;
}

.class-list-content .class-station span {
  color: #e88a1b;
  position: absolute;
  left: 0;
}

.class-list-content .class-node {
  margin: 5px 0;
  padding-left: 15px;
  position: relative;
  line-height: 18px;
}

.class-list-content .class-node span {
  color: #23a737;
  position: absolute;
  left: 0;
}

.class-list-content .class-distance {
  font-size: 12px;
  color: #999;
}

.class-list-content .class-distance span {
  font-size: 12px;
  color: #333;
}

.class-list-content .class-right-model {
  width: 150px;
}

.class-list-content .class-right-model > div {
  text-align: right;
}

.class-list-content .class-right-model .class-price {
  color: #eb5c03;
  font-size: 20px;
  font-weight: 700;
  margin-left: 10px;
}

.class-list-content .class-right-model .class-seats {
  color: rgb(109, 55, 55);
  font-size: 16px;
  line-height: 30px;
}

.class-list-content .class-right-model .class-btn-confirm {
  background-color: #eb5c03;
  border-radius: 5px;
  padding: 0 5px;
  line-height: 18px;
  font-size: 12px;
  text-align: center;
  color: #fff;
}

.style_2 {
    .class-time{
      padding-right: 10px;
      text-align: center;
      font-weight: 600;
      font-size: 18px;
      line-height: 18px;
      width:50px;
    }

   .class-time-tip {
      padding-right: 10px;
      text-align: center;
      font-size: 12px; 
      min-width:50px;
    }

    .class-schedule{
        line-height: 18px;
        font-size: 15px;
        font-weight: 600;

       span.start {
      font-size: 13px;
        color: #e88a1b;
      }
   }

   .class-desc{
     
    font-size: 14px;
    color: #999;
    padding-top:5px;

    span.linename {
     font-size: 13px;
      color: #23a737;
    }

    span.linenode {
      font-size: 13px;
      color: #333;
    }
 
  }

  .class-price {
    color: #eb5c03;
    font-size: 18px;
    line-height: 16px;
    font-weight: 600;
    margin-left: 10px;
  }

  .class-seats {
    color: rgb(214, 50, 50);
   
    line-height: 12px;
    span{
      font-size: 15px;
    }
  }

}

</style>
